import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

interface SummaryCardsProps {
  delayed: number;
  onTime: number;
  highRisk: number;
  onCardClick?: (filterType: 'delayed' | 'onTime' | 'mediumRisk' | null) => void;
  selectedFilter?: 'delayed' | 'onTime' | 'mediumRisk' | null;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({ delayed, onTime, highRisk, onCardClick, selectedFilter }) => {
  const handleClick = (filterType: 'delayed' | 'onTime' | 'mediumRisk') => {
    if (!onCardClick) return;
    onCardClick(selectedFilter === filterType ? null : filterType);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 4, flexWrap: 'wrap' }}>
      <Card 
        variant="outlined" 
        onClick={() => handleClick('onTime')}
        sx={{ 
          borderLeft: '4px solid #10b981',
          borderRadius: 2,
          cursor: 'pointer',
          width: 'calc(33.333% - 11px)',
          minWidth: '250px',
          bgcolor: selectedFilter === 'onTime' ? '#ecfdf5' : 'inherit',
          boxShadow: selectedFilter === 'onTime' ? '0 0 0 2px #10b981' : 'none',
          transition: 'all 0.2s',
          '&:hover': { bgcolor: '#ecfdf5' },
        }}
      >
        <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#10b981', fontWeight: 500, mb: 0.5 }}>
              Total On Time Shipments
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 0.5 }}>
              {onTime}
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b' }}>
              Based on current filters
            </Typography>
          </Box>
          <Box sx={{ 
            width: 40, 
            height: 40, 
            borderRadius: '50%', 
            bgcolor: '#ecfdf5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <TrendingUpIcon sx={{ color: '#10b981' }} />
          </Box>
        </CardContent>
      </Card>

      <Card 
        variant="outlined" 
        onClick={() => handleClick('delayed')}
        sx={{ 
          borderLeft: '4px solid #ef4444',
          borderRadius: 2,
          cursor: 'pointer',
          width: 'calc(33.333% - 11px)',
          minWidth: '250px',
          bgcolor: selectedFilter === 'delayed' ? '#fef2f2' : 'inherit',
          boxShadow: selectedFilter === 'delayed' ? '0 0 0 2px #ef4444' : 'none',
          transition: 'all 0.2s',
          '&:hover': { bgcolor: '#fef2f2' },
        }}
      >
        <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#ef4444', fontWeight: 500, mb: 0.5 }}>
              Total Delayed Shipments
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 0.5 }}>
              {delayed}
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b' }}>
              Based on current filters
            </Typography>
          </Box>
          <Box sx={{ 
            width: 40, 
            height: 40, 
            borderRadius: '50%', 
            bgcolor: '#fef2f2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <TrendingDownIcon sx={{ color: '#ef4444' }} />
          </Box>
        </CardContent>
      </Card>

      {/* <Card 
        variant="outlined" 
        onClick={() => handleClick('mediumRisk')}
        sx={{ 
          borderLeft: '4px solid #f59e0b',
          borderRadius: 2,
          cursor: 'pointer',
          bgcolor: selectedFilter === 'mediumRisk' ? '#fffbeb' : 'inherit',
          boxShadow: selectedFilter === 'mediumRisk' ? '0 0 0 2px #f59e0b' : 'none',
          transition: 'all 0.2s',
          '&:hover': { bgcolor: '#fffbeb' },
        }}
      >
        <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#f59e0b', fontWeight: 500, mb: 0.5 }}>
              Total Medium Risk Shipments
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 0.5 }}>
              {highRisk}
            </Typography>
            <Typography variant="caption" sx={{ color: '#64748b' }}>
              Based on current filters
            </Typography>
          </Box>
          <Box sx={{ 
            width: 40, 
            height: 40, 
            borderRadius: '50%', 
            bgcolor: '#fffbeb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <WarningAmberIcon sx={{ color: '#f59e0b' }} />
          </Box>
        </CardContent>
      </Card> */}
    </Box>
  );
};

export default SummaryCards;
